import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {ExcelExportQueryKey, ExpertSystemEquipmentType} from '../types'

export const useExport = (
  kpiTargetEquipmentType: ExpertSystemEquipmentType,
  year: number,
  options?: Omit<UseQueryOptions<Blob, AxiosError>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<Blob, AxiosError>({
    queryKey: [ExcelExportQueryKey, year, kpiTargetEquipmentType],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<Blob>(
        `/expert-system/kpis/${kpiTargetEquipmentType}/${year}/excel`,
        {
          responseType: 'blob',
          signal
        }
      )

      return response.data
    },
    refetchOnMount: false,
    staleTime: Infinity,
    ...options
  })
}
